module.exports = __webpack_public_path__ + "static/media/email.0a3a3edc.png";